<template>
  <v-list-item link :input-value="isActive" @click="handleClick" class="my-2 py-1 nav_item"
    :class="{ 'px-3': !minimizedDrawer, 'nav_item--active-custom': isActive }" color="plusPrimary"
    :data-v-step="dataVStep">
    <template v-slot:default="{ active }">
      <v-list-item-action>
        <div v-if="active && !$vuetify.breakpoint.smAndDown" class="nav-active-indicator"></div>
        <v-badge v-if="badge && badge > 0" :content="badge" color="error" overlap>
          <v-icon :color="active ? 'plusIndigoDarken3' : 'plusGreyDarken3'">{{
            icon
            }}</v-icon>
        </v-badge>
        <v-icon v-else
          :color="$vuetify.breakpoint.smAndDown ? 'plusTextOnSecondary' : active ? 'plusIndigoDarken3' : ''">{{
            icon
          }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title :class="[
          'font-roboto body-1',
          active ? 'active-text' : $vuetify.breakpoint.smAndDown ? 'plusTextOnSecondary--text' : 'plusGreyDarken3--text',
        ]">{{ title }}</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-list-item>
</template>

<style scoped>
.nav_item::before,
.nav_item::after {
  opacity: 0 !important;
  border-radius: 4px;
}

.nav_item.v-list-item--active::before {
  opacity: 0 !important;
}

.nav-active-indicator {
  position: absolute;
  left: 4px;
  top: 4px;
  width: 4px;
  height: calc(100% - 8px);
  background-color: #303F9F;
  border-radius: 2px;
  z-index: 10;
}

.nav_item--active-custom {
  background: linear-gradient(90deg, #E8EAF6 0%, #FAFAFA 90.87%) !important;
  border-radius: 4px !important;
  padding-left: 16px !important;
}

.nav_item--active-custom::before {
  opacity: 0 !important;
}

.nav_item .v-ripple__container {
  opacity: 0 !important;
}

.nav_item .v-list-item__title {
  z-index: 1000;
}

.active-text {
  color: #283593 !important;
}

@media (max-width: 960px) {

  .active-text {
    color: #FFFF !important;
  }

  .nav_item--active-custom {
    background: #5C6BC0 !important;
  }

  .nav-active-indicator {
    background-color: #5C6BC0;
  }
}
</style>

<script>
export default {
  name: "NavItem",
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    routeName: {
      type: String,
      default: null,
    },
    routeNames: {
      type: Array,
      default: () => [],
    },
    badge: {
      type: Number,
      default: null,
    },
    minimizedDrawer: {
      type: Boolean,
      default: false,
    },
    dataVStep: {
      type: String,
      default: null,
    },
  },
  computed: {
    isActive() {
      if (this.routeNames && this.routeNames.length > 0) {
        return this.routeNames.includes(this.$route.name);
      }
      return this.$route.name === this.routeName;
    },
  },
  methods: {
    handleClick() {
      this.$emit("click");
      this.$emit("navigate", this.routeName);
    },
  },
};
</script>
